import classes from "./style/LoginRegisterLayout.module.css";
import React, { HTMLAttributes } from "react";
import { Flex, Typography } from "antd";
import { Logo } from "../../components/Logo/Logo";

const { Text } = Typography;

interface LoginLayoutProps extends HTMLAttributes<HTMLDivElement> {
  classNameMain?: string;
}
export const LoginLayout = ({
  children,
  classNameMain,
  ...restProps
}: LoginLayoutProps) => {
  const currentYear = new Date().getFullYear();
  const concatClassNameMain = `${classes.main} ${classNameMain}`;
  return (
    <div {...restProps} className={classes.wrapper}>
      <div className={classes.container}>
        <header className={classes.header}>
          <Logo to="/login" />
        </header>

        <main className={concatClassNameMain}>{children}</main>

        <Flex
          justify="space-between"
          wrap
          component={"footer"}
          className={classes.footer}
        >
          <div className={classes.footerItem}>
            <Text type="secondary">
              © it_online_{currentYear}. Все права защищены.
            </Text>
          </div>

          <div className={classes.footerItem}>
            <Text type="secondary">Политика обработки персональных данных</Text>
          </div>
        </Flex>
      </div>
    </div>
  );
};
